import axios from 'axios';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const useCrearVenta = () => {
  const queryClient = useQueryClient();

  const { getJwtToken } = useAuth();
  
  return useMutation({
    mutationFn: async ( payload ) => {
      const token = await getJwtToken();
      const { data } = await axios.post(
        `${API_BASE_URL}/v1-ventas`, 
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    },
    onSuccess: () => {
      // Refrescamos productos para ver el nuevo stock
      queryClient.invalidateQueries({ queryKey: ['productos'] });
      queryClient.invalidateQueries({ queryKey: ['ventas-sesion'] });
      queryClient.invalidateQueries({ queryKey: ['stock_bodega'] });
    }
  });
};

// para listar las ventas del usuario de esa sesion
export const useVentasSesion = (sesionCajaId) => {
  const { getJwtToken } = useAuth();
  
  return useQuery({
      queryKey: ['ventas-sesion', sesionCajaId], 
      queryFn: async () => {
          if (!sesionCajaId) return [];
          const token = await getJwtToken();
          const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1-ventas?sesion_id=${sesionCajaId}`, {
              headers: { Authorization: `Bearer ${token}` }
          });
          return data;
      },
      enabled: !!sesionCajaId,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
  });
};

export const useHistorialVentasGlobal = (fechaInicio, fechaFin, estadoPago) => {
  const { getJwtToken } = useAuth();
  
  return useQuery({
      queryKey: ['historial-ventas-global', fechaInicio, fechaFin, estadoPago], 
      queryFn: async () => {
          if (!fechaInicio || !fechaFin) return [];
          const token = await getJwtToken();
          const url = `${process.env.REACT_APP_API_URL}/v1-ventas?fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&status_pago=${estadoPago}`;
          
          const { data } = await axios.get(url, {
              headers: { Authorization: `Bearer ${token}` }
          });
          return data;
      },
      enabled: !!fechaInicio && !!fechaFin,
  });
};

export const useNotasCredito = () => {
  const { getJwtToken } = useAuth();
  
  return useQuery({
      queryKey: ['notas-credito'], 
      queryFn: async () => {
          const token = await getJwtToken();
          const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1-notas-credito`, {
              headers: { Authorization: `Bearer ${token}` }
          });
          return data;
      }
  });
};